var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "radio-group",
      class: { "has-error": _vm.localErrors.length }
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c("x-errors-messages", { attrs: { errors: _vm.localErrors } })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }